import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {NotificationListComponent} from '@lib/components/notifications/notification-list.component';

@Component({
  selector: 'px-recent-notifications',
  host: {
    class: 'grow'
  },
  template: `
    <mat-card class="w-full">
      <mat-card-content>
        <px-notification-list [isDashboardView]="true"/>
      </mat-card-content>
    </mat-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, NotificationListComponent]
})
export class RecentNotificationsComponent {
}
